import { render, staticRenderFns } from "./grupoVeiculos.vue?vue&type=template&id=06087406"
import script from "./grupoVeiculos.vue?vue&type=script&lang=js"
export * from "./grupoVeiculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports